import { WizardConfig } from '../../types/wizard'

interface Props {
  config: WizardConfig
}

export default function Step5Review({ config }: Props) {
  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-2">Review Your Configuration</h2>
      <p className="text-gray-600 mb-8">
        Please review your chatbot configuration before proceeding to checkout.
      </p>

      <div className="space-y-6">
        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-4">Agent Information</h3>
          <dl className="grid grid-cols-1 gap-3">
            <div>
              <dt className="text-sm text-gray-600">Name</dt>
              <dd className="text-base font-medium text-gray-900">{config.agentName}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-600">Email</dt>
              <dd className="text-base font-medium text-gray-900">{config.email}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-600">Phone</dt>
              <dd className="text-base font-medium text-gray-900">{config.phone}</dd>
            </div>
          </dl>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-4">Calendly</h3>
          <dl>
            <div>
              <dt className="text-sm text-gray-600">Calendly URL</dt>
              <dd className="text-base font-medium text-gray-900 break-all">{config.calendlyUrl}</dd>
            </div>
          </dl>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-4">Market Settings</h3>
          <dl className="space-y-3">
            <div>
              <dt className="text-sm text-gray-600 mb-2">Cities</dt>
              <dd className="flex flex-wrap gap-2">
                {config.cities.map(city => (
                  <span key={city} className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium">
                    {city}
                  </span>
                ))}
              </dd>
            </div>
            <div>
              <dt className="text-sm text-gray-600 mb-2">Price Ranges</dt>
              <dd className="flex flex-wrap gap-2">
                {config.priceRanges.map(range => (
                  <span key={range} className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium">
                    {range}
                  </span>
                ))}
              </dd>
            </div>
          </dl>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-4">Branding</h3>
          <dl className="space-y-3">
            <div>
              <dt className="text-sm text-gray-600 mb-2">Primary Color</dt>
              <dd className="flex items-center gap-3">
                <div
                  className="w-8 h-8 rounded border border-gray-300"
                  style={{ backgroundColor: config.primaryColor }}
                />
                <span className="text-base font-medium text-gray-900">{config.primaryColor}</span>
              </dd>
            </div>
            {config.botNamePreference && (
              <div>
                <dt className="text-sm text-gray-600">Bot Name Preference</dt>
                <dd className="text-base font-medium text-gray-900">{config.botNamePreference}</dd>
              </div>
            )}
          </dl>
        </div>

        <div className="bg-primary-50 border-2 border-primary-200 rounded-lg p-6">
          <h3 className="font-semibold text-primary-900 mb-2">What Happens Next?</h3>
          <ul className="space-y-2 text-sm text-primary-800">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Complete payment via Stripe secure checkout</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Receive your embed code via email instantly</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Add code to your website (takes 2 minutes)</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Start capturing leads 24/7!</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
